import script from "./PipelineVacancyDraftsOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./PipelineVacancyDraftsOverlay.vue?vue&type=script&setup=true&lang=js"

import "./PipelineVacancyDraftsOverlay.vue?vue&type=style&index=0&id=0904a459&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0904a459"]])

export default __exports__